<script lang="ts">
  import { onMount } from "svelte";
  import { get } from "lodash";
  import { pluralize } from "@shared/svelte/Modules/pluralize";
  import * as ProductHelpers from "@shared/svelte/ProductHelpers.js";
  import QuickOrderListProductsStore from "@retailer/svelte/stores/QuickOrderListProductsStore";
  import { InventoryItemStore } from "@retailer/svelte/CartWidget/v2/Stores/InventoryItemStore";
  import * as _ from "lodash";

  export let cartProduct;

  export let inventoryChangePending: boolean;

  onMount(async () => {
    await InventoryItemStore.fetchInventoryItem(cartProduct.inventory_id);
  });

  $: inventoryItemSoldBy = $InventoryItemStore?.inventoryItems[cartProduct.inventory_id]?.sold_by;
  const soldInCases: boolean = ProductHelpers.soldInCases(
    cartProduct.product,
    cartProduct.product_line,
    inventoryItemSoldBy,
  );

  const soldInUnitsOrKegs: boolean =
    ProductHelpers.isKeg(cartProduct.product) ||
    ProductHelpers.soldInUnits(cartProduct.product, cartProduct.product_line, inventoryItemSoldBy);

  const updateInventoryValueApi = async function () {
    inventoryChangePending = true;
    const productId = cartProduct.product_id;
    try {
      await QuickOrderListProductsStore.updateInventory([
        {
          ...cartProduct.retailer_inventory,
          product_id: productId,
        },
      ]);
    } catch {
      // TODO
    } finally {
      inventoryChangePending = false;
    }
  };

  const updateInventoryValue = async e => {
    const attributeName = e.target.dataset.attributeName;
    if (!cartProduct) {
      return;
    }
    if (!cartProduct?.retailer_inventory) {
      cartProduct.retailer_inventory = {};
    }

    const currentValue = get(cartProduct, `retailer_inventory.${attributeName}`, null);

    if (e.target.value === "" && currentValue === null) return;

    if (e.target.value === "" && currentValue === 0) {
      e.target.value = 0;
      return;
    }
    const inputValue = Number(e.target.value);
    cartProduct.retailer_inventory[attributeName] = inputValue;
    if (inputValue !== currentValue) {
      updateInventoryValueApi();
    }
  };
</script>

<style>
  .retail-inventory-input {
    width: 4rem;
  }
</style>

<td>
  <div class="fizz-flex-row">
    <div class="fizz-flex-item">
      <h4 class="fizz-hide-on-large fizz-stack-8">On Hand</h4>
      {#if soldInUnitsOrKegs}
        <div class="fizz-flex-row" class:fizz-stack-12={soldInCases}>
          <input
            disabled={inventoryChangePending}
            data-attribute-name="units_on_hand"
            class="fizz-input-text retail-inventory-input"
            name={`units_on_hand_${cartProduct.product_id}`}
            id={`units_on_hand_${cartProduct.product_id}`}
            type="number"
            on:blur={updateInventoryValue}
            value={get(cartProduct, `retailer_inventory.units_on_hand`, "")}
          />
          <label for={`units_on_hand_${cartProduct.product_id}`}>
            {pluralize(
              cartProduct.product.container_type,
              get(cartProduct, `retailer_inventory.units_on_hand`, ""),
            )}
          </label>
        </div>
      {/if}

      {#if soldInCases}
        <div class="fizz-flex-row">
          <input
            disabled={inventoryChangePending}
            data-attribute-name="cases_on_hand"
            class="fizz-input-text retail-inventory-input"
            name={`cases_on_hand_${cartProduct.product_id}`}
            id={`cases_on_hand_${cartProduct.product_id}`}
            type="number"
            on:blur={updateInventoryValue}
            value={get(cartProduct, `retailer_inventory.cases_on_hand`, "")}
          />
          <label for={`cases_on_hand_${cartProduct.product_id}`}>cases</label>
        </div>
      {/if}
    </div>

    <div class="fizz-flex-item">
      <h4 class="fizz-hide-on-large fizz-stack-8">Par</h4>
      {#if soldInUnitsOrKegs}
        <div class="fizz-flex-row" class:fizz-stack-12={soldInCases}>
          <input
            disabled={inventoryChangePending}
            data-attribute-name="units_par"
            class="fizz-input-text retail-inventory-input"
            name={`units_par_${cartProduct.product_id}`}
            id={`units_par_${cartProduct.product_id}`}
            type="number"
            on:blur={updateInventoryValue}
            value={get(cartProduct, `retailer_inventory.units_par`, "")}
          />
          <label for={`units_par_${cartProduct.product_id}`}>
            {pluralize(
              cartProduct.product.container_type,
              get(cartProduct, `retailer_inventory.units_par`, ""),
            )}
          </label>
        </div>
      {/if}

      {#if soldInCases}
        <div class="fizz-flex-row">
          <input
            disabled={inventoryChangePending}
            data-attribute-name="cases_par"
            class="fizz-input-text retail-inventory-input"
            name={`cases_par_${cartProduct.product_id}`}
            id={`cases_par_${cartProduct.product_id}`}
            type="number"
            on:blur={updateInventoryValue}
            value={get(cartProduct, `retailer_inventory.cases_par`, "")}
          />
          <label for={`cases_par_${cartProduct.product_id}`}>cases</label>
        </div>
      {/if}
    </div>
  </div>
</td>
